// const initialState = {
//     profile: {
//         email: '',
//         first_name: '',
//         last_name: '',
//         phone: '',
//         dob: '',
//         gender: '',
//         address: '',
//         city: '',
//         state: '',
//         country: '',
//         pincode: '',
//         profile_pic: null,
//         limit: 0,
//         ai_token: 0,
//         available_tokens: 0,
//     },
//     loading: false,
//     error: null,
// };

// const userReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case 'USER_PROFILE_REQUEST':
//             return { ...state, loading: true };
//         case 'USER_PROFILE_SUCCESS':
//             return { ...state, loading: false, profile: action.payload };
//         case 'USER_PROFILE_FAILURE':
//             return { ...state, loading: false, error: action.error };
//         default:
//             return state;
//     }
// };

// export default userReducer;




import TYPE from "./Type";

const initialState = {
    access: localStorage.getItem('access'),
    userDetails: null,
    message: ""
}

const userReducer = (state=initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TYPE.GET_USER_DETAILS_SUCCESS:
            return {
                ...state,
                userDetails: payload
            }
        case TYPE.GET_USER_DETAILS_FAIL:
            return {
                ...state,
                userDetails: null
            }
        default:
            return state;
    }
}

export default userReducer;
